import { create } from 'zustand';

/**
 * Toggle unico "Mostra non compatibili" del configuratore Motornet: vale per tutte
 * le tab (colori/optional/pacchetti) e sostituisce il vecchio reveal per-categoria.
 * Lo stato è persistito in localStorage così sopravvive al reload.
 *
 * Default `false` = non compatibili nascosti.
 */
const KEY = 'horizon.motornet.showIncompatible';

function read(): boolean {
	if (typeof window === 'undefined') return false;
	try {
		const raw = window.localStorage.getItem(KEY);
		return raw != null ? JSON.parse(raw) === true : false;
	} catch {
		return false;
	}
}

function write(value: boolean): void {
	if (typeof window === 'undefined') return;
	try {
		window.localStorage.setItem(KEY, JSON.stringify(value));
	} catch {
		// storage non disponibile (private mode / quota): il toggle resta comunque
		// funzionante in-memory per la sessione corrente.
	}
}

type ShowIncompatibleState = {
	show: boolean;
	toggle: () => void;
};

export const useShowIncompatible = create<ShowIncompatibleState>((set) => ({
	show: read(),
	toggle: () =>
		set((s) => {
			const next = !s.show;
			write(next);
			return { show: next };
		}),
}));
